var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { Text } from '@inter-ikea-kompis/component-text';
/**
 * SheetBodyPadding component.
 */
export default class SheetBodyPadding extends KompisElement {
    constructor() {
        super(...arguments);
        this.bottomPadding = false;
        this.topPadding = false;
    }
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        const { spacing, breakpoint } = this.theme;
        return html `
			<style>
				:host {
					display: block;
					padding: 0 ${spacing.space150 / 16}rem;
					padding-top: ${this.topPadding ? spacing.space300 / 16 + 'rem' : 0};
					padding-bottom: ${this.bottomPadding ? spacing.space300 / 16 + 'rem' : 0};
				}
				@media screen and (max-width: ${breakpoint.medium.width / 16}rem) {
					:host {
						padding: 0 ${spacing.space150 / 16}rem;
						padding-top: ${this.topPadding ? spacing.space150 / 16 + 'rem' : 0};
						padding-bottom: ${this.bottomPadding ? spacing.space150 / 16 + 'rem' : 0};
					}
				}
				@media screen and (min-width: ${breakpoint.large.width / 16}rem) {
					:host {
						padding: 0 ${spacing.space300 / 16}rem;
						padding-bottom: ${this.bottomPadding ? spacing.space200 / 16 + 'rem' : 0};
					}
				}
			</style>
			<div>
				<slot></slot>
			</div>
		`;
    }
    connectedCallback() {
        this.customElements.define('kompis-text', Text);
        super.connectedCallback();
    }
}
__decorate([
    property({ type: Object, required: true })
], SheetBodyPadding.prototype, "theme", void 0);
__decorate([
    property({ type: Boolean })
], SheetBodyPadding.prototype, "bottomPadding", void 0);
__decorate([
    property({ type: Boolean })
], SheetBodyPadding.prototype, "topPadding", void 0);
//# sourceMappingURL=SheetBodyPadding.js.map